export default __webpack_public_path__ + "static/media/06fb138dfbae9e7f19d3103709e0d4cd.svg";